/**
 * Each space answers on its own host, and one build serves them all: the host is what tells the
 * Services space apart, in the middleware as in the pages. Left empty, the variable makes every
 * host serve every space: a missing variable must not make the application unreachable.
 */
export const servicesHostname =
  process.env.NEXT_PUBLIC_SERVICES_HOST?.split(':')[0]

export const isServicesHostname = (host: string | null | undefined) =>
  Boolean(servicesHostname) && (host ?? '').split(':')[0] === servicesHostname

/**
 * Clever Cloud terminates TLS upstream, so the browser hostname only reaches us through
 * `x-forwarded-host`. Reads the middleware's request headers as well as a server component's.
 */
export const isServicesRequest = (headers: {
  get(name: string): string | null
}) => isServicesHostname(headers.get('x-forwarded-host') ?? headers.get('host'))

/** The origin the Services space answers on, reached on the port the current page is served from. */
export const getServicesOrigin = () => {
  const { protocol, port, origin } = window.location
  return servicesHostname
    ? `${protocol}//${servicesHostname}${port ? `:${port}` : ''}`
    : origin
}
